import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/Parag-kumbhar'
      className='link footer__link'
    >
      Created By Parag Kumbhar
    </a>
  </footer>
)

export default Footer
